import { formatDateForServer } from '@/utils/format/date'
export function getFirstAndLastDaysMonth (startDate, endDate) {
  const start = new Date(startDate)
  const end = new Date(endDate)

  const result = []

  let current = start

  while (current <= end) {
    let lastDay = new Date(current.getFullYear(), current.getMonth() + 1, 0)
    if (lastDay > end) {
      lastDay = end
    }

    result.push({
      date_start: formatDateForServer(new Date(current)),
      date_finish: formatDateForServer(lastDay)
    })

    current = new Date(current.getFullYear(), current.getMonth() + 1, 1)
  }
  return result
}
